import { languageController } from "../controllers/language/languageController";
import { localStorageKeys } from "./constants";
import { getEndpointUrl } from "./endPoints";
import { getItemOnLocalStorage, setItemOnLocalStorage } from "./helpers";
import { handleRequest } from "./httpRequest";

// Return dealers only in the current viewport/bounds
export const getDealersInViewport = (dealers, currentBounds) => {
  if (currentBounds) {
    const { minLat, maxLat, minLong, maxLong } = currentBounds;
    const filterdDealers = dealers.filter(({ geolocation }) => {
      return (
        (geolocation.latitude > minLat) &&
        (geolocation.latitude < maxLat) &&
        (geolocation.longitude > minLong) &&
        (geolocation.longitude < maxLong)
      )
    })
    return filterdDealers
  }

  return dealers
}

// Return current bounds' min lat/lng and max lat/lng
export const getCurrentBounds = (map) => {
  const bounds = map.getBounds();
  return ({
    minLat: bounds.getSouthWest().lat(),
    maxLat: bounds.getNorthEast().lat(),
    minLong: bounds.getSouthWest().lng(),
    maxLong: bounds.getNorthEast().lng(),
  })
}

// Convert postalcode to coordinates (lat and lng)
export const convertPostalToCoordinates = async (postalCode) => {
  try {
    const coordinates = await handleRequest('get', `${getEndpointUrl('geolocation')}?postcode=${postalCode}`);
    if (coordinates) {
      return {
        lat: coordinates.lat,
        lng: coordinates.long
      }
    }
    return null;
  } catch (err) {
    console.log(err)
  }
}

// Return curretn position if permitted
function getUserCurrentPosition(options = {}) {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  );
}

// Return user's geolcoation using Geolocation API
export const getUserGeoLocation = async () => {
  if (navigator.geolocation) {
    try {
      const position = await getUserCurrentPosition();
      return {
        success: true,
        data: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      }
    } catch (err) {
      let errText = ''
      console.log(err)
      switch (err.code) {
        case err.PERMISSION_DENIED: // 1
          errText = languageController.getCopy('findDealer', 'geoDenied');
          break;
        case err.POSITION_UNAVAILABLE: // 2
          errText = languageController.getCopy('findDealer', 'geoUnavailable');
          break;
        case err.TIMEOUT: // 3
          errText = languageController.getCopy('findDealer', 'geoTimeout');
          break;
        case err.UNKNOWN_ERROR:
          errText = languageController.getCopy('findDealer', 'geoUnavailable');
          break;
      }

      return {
        success: false,
        data: errText
      }
    }
  } else {
    return {
      success: false,
      data: languageController.getCopy('findDealer', 'geoUnavailable')
    }
  }
}

// Return link for google direction
export const generateGoogleDirection = (from, to) => {
  if (!from || !to) {
    console.error('Error: "form" or "to" is undefined in generateGoogleDirection')
    return ''
  }
  return `https://www.google.com/maps/dir/${from.lat},${from.lng}/${to.lat},${to.lng}`
}

// Store user location data in localstorage.
export const storeUserLocation = (type, value) => {
  if (type === 'geolocation') {
    setItemOnLocalStorage(localStorageKeys.USER_GEO_LOCATION, value);
  } else if (type === 'postalcode') {
    setItemOnLocalStorage(localStorageKeys.USER_POSTALCODE, value);
  }
}

// Get a location that user has set previously on the site.
export const getPreviousUserlocation = () => {
  const geolocation = getItemOnLocalStorage(localStorageKeys.USER_GEO_LOCATION);
  if (geolocation) {
    return {
      type: 'geolocation',
      value: geolocation
    };
  }

  const postalcode = getItemOnLocalStorage(localStorageKeys.USER_POSTALCODE);
  if (postalcode) {
    return {
      type: 'postalcode',
      value: postalcode
    };
  }

  return null;
}